export default __webpack_public_path__ + "maps-examples-custom-style-thumbnail-480-5fa3329fa2b553e6f316bd13a3c23349.webp";